// ABOUTME: The rules a discussion message's text obeys before it is sent — length in Unicode code
// ABOUTME: points, blank only with attachments, no zero character — so the server never has to refuse them.

/**
 * The server counts Unicode code points, not UTF-16 units: 👍 is one character, not two
 * (`gql-api/docs/frontend-discussion.md` §1). The markup of a MARKDOWN text counts too.
 */
export const MESSAGE_MAX_LENGTH = 4000

/** Attachments one message carries at most — pictures, videos and files together. */
export const MESSAGE_MAX_ATTACHMENTS = 10

export const textLength = (text: string): number => [...text].length

/** Blank is what the server calls empty: nothing left after trimming the spaces. */
export const isBlankText = (text: string): boolean => text.trim() === ""

/** A blank text goes only with an attachment, and no text goes over the limit. */
export const canSendMessage = ({ text, attachmentCount }: { text: string; attachmentCount: number }): boolean =>
  (attachmentCount > 0 || !isBlankText(text)) && textLength(text) <= MESSAGE_MAX_LENGTH

/**
 * The text as it goes to the server. A zero character (U+0000) is refused there with
 * ErrInvalidParameters; it is invisible, so it is dropped rather than explained. Spaces stay:
 * the server stores a text as sent.
 */
export const sendableText = (text: string): string => text.replaceAll("\u0000", "")
